import { useQuery } from '@apollo/client/react';
import { Box, Grid, Stack, Card, Typography, CardContent } from '@mui/material';
import dayjs from 'dayjs';
import { titleize } from 'inflection';
import { map } from 'lodash';
import { useContext } from 'react';

import CurrentUserContext from '@/Contexts/CurrentUser';
import { ReportContext } from '@/Contexts/ReportContext';
import { GetDeliveryItemStatesDocument } from '@/graphql/generated/graphql';
import { objectLength } from '@/utils/helperFunctions';

const DeliveryAndCollectionRegister = () => {
  const { dateTimePreference } = useContext(CurrentUserContext);
  const { selectedReport } = useContext(ReportContext);
  const { data } = useQuery(GetDeliveryItemStatesDocument, {
    fetchPolicy: 'cache-and-network',
    skip: !selectedReport,
    variables: { reportId: selectedReport?.id as string },
  });

  return (
    <Card elevation={1} sx={{ height: '100%' }}>
      <Box sx={{ p: 2, bgcolor: '#e3f2fd', display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="h6" sx={{ color: '#0d47a1', fontWeight: 600 }}>
          Delivery &amp; Collection
        </Typography>
      </Box>

      <CardContent>
        {!objectLength(data?.getDeliveryItemStates) ? (
          <Typography variant="body2" color="textSecondary">
            No delivery or collection records available.
          </Typography>
        ) : (
          map(data?.getDeliveryItemStates, (state, index) => {
            const { item } = state;
            return (
              <Grid
                key={`${item.id}-${index}`}
                container
                alignItems="center"
                sx={{
                  '&:not(:last-of-type)': {
                    borderBottom: '1px solid',
                    borderBottomColor: 'divider',
                    paddingBottom: 2,
                    marginBottom: 2,
                  },
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                  <Stack>
                    <Typography variant="overline" color="textSecondary" sx={{ lineHeight: 1 }}>
                      {`${titleize(state.currentState)} At: ${dayjs(state.currentStateSetAt).format(dateTimePreference.time)}`}
                    </Typography>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                      {item.companyResource.name} {item.companyResource.resourceMeta?.shortCode}
                    </Typography>
                  </Stack>
                  <Typography variant="caption">Quantity: {item.quantity}</Typography>
                </Box>

                <Grid
                  size={12}
                  container
                  spacing={2}
                  mt={1}
                  sx={{ '.MuiGrid-root:not(:last-of-type)': { borderRight: '1px solid', borderRightColor: 'divider' } }}
                >
                  <Grid size={4}>
                    <Typography variant="caption" color="textSecondary">
                      Receiver
                    </Typography>
                    <Typography variant="body2">{state.receiverName}</Typography>
                  </Grid>
                  <Grid size={4}>
                    <Typography variant="caption" color="textSecondary">
                      Deliverer
                    </Typography>
                    <Typography variant="body2">{state.delivererName}</Typography>
                  </Grid>
                  <Grid size={4}>
                    <Typography variant="caption" color="textSecondary">
                      Supplier
                    </Typography>
                    <Typography variant="body2">{state.supplier}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            );
          })
        )}
      </CardContent>
    </Card>
  );
};

export default DeliveryAndCollectionRegister;
